import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCircledCrossWithExclamation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} width="79" height="79" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_100_6493)">
        <circle
          cx="41.5"
          cy="40.8047"
          r="37.5"
          stroke="url(#paint0_linear_100_6493)"
          strokeWidth="20"
        />
        <path
          d="M37 35.3047L47 45.3047M47 35.3047L37 45.3047"
          stroke="#0C1C43"
          strokeLinecap="round"
        />
      </g>
      <rect y="0.304688" width="30" height="30" rx="15" fill="#B01921" />
      <rect x="0.5" y="0.804688" width="29" height="29" rx="14.5" stroke="white" />
      <path
        d="M15 9.30469V16.3047M15 19.3047V20.3047"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100_6493"
          x1="41.5"
          y1="3.30469"
          x2="41.1775"
          y2="59.9546"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.5} stopColor="#DB646A" stopOpacity={0.25} />
          <stop offset={1} stopColor="#DB646A" stopOpacity={0.65} />
        </linearGradient>
        <clipPath id="clip0_100_6493">
          <rect x="4" y="3.30469" width="75" height="75" rx="37.5" fill="white" />
        </clipPath>
        <clipPath id="clip1_100_6493">
          <rect y="0.304688" width="30" height="30" rx="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgCircledCrossWithExclamation);
export default ForwardRef;
